// import { UserPermissionService } from '../../../services/user-permission-service';
import { fetchReturnRabbitAddOn } from '../../../pages/settings/api/add-ons-api';
import { manageSubscription } from '../../../pages/settings/api/subscription';
import { isNewLineupPlanProfileAndBillingPlan } from '../../../feature-gates/feature-gate-helper';

export const getDataForUsersWithAccountManagementRole = (data) => {
  // oxlint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    // todo return this when we're not in a rush.
    // const { roles } = data.input.currentUser;
    // const isAccountManager = UserPermissionService.userHasAccountManagementRole(roles);
    // const isSystemAdministrator = UserPermissionService.userIsSystemAdministrator(roles);
    // if (!isAccountManager && !isSystemAdministrator) {
    //   resolve({
    //     planInfo: {},
    //     subscriptionData: {},
    //   });
    //   return;
    // }

    try {
      const manageSubscriptionResponse = await manageSubscription();
      if (manageSubscriptionResponse?.status && manageSubscriptionResponse.status !== 200) {
        throw new Error(manageSubscriptionResponse.statusText);
      }
      const subscriptionData = manageSubscriptionResponse.data || {};
      const newData = {
        subscriptionData,
      };

      // The Return Rabbit add-on is injected through the FE code instead of being treated the same as
      // other add-ons coming from the BE. This feature is no longer available as an add-on for new, feature gated plans,
      // so don't fetch it for those plans.
      const sellerPlanProfileId = data.input.seller?.subscriptionPlanInfo?.planProfileId;
      const sellerBillingPlanId = data.input.seller?.subscriptionPlanInfo?.billingPlanId;
      if (sellerPlanProfileId && sellerBillingPlanId && !isNewLineupPlanProfileAndBillingPlan(sellerPlanProfileId, sellerBillingPlanId)) {
        // Don't error the app on this failing. Should have catch built in
        // Don't await on this to avoid blocking app load on external dep
        fetchReturnRabbitAddOn();
      }

      resolve(newData);
    } catch (e) {
      reject(e);
    }
  });
};
